import builder from '../builder';
import Bin1 from '../../streamline-icons/bold/bin-1.svg';

export default builder('IconBin1Bold', Bin1);
